// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"3830c53f","707":"e46e6c1f","963":"3830c53f"}[chunkId] + ".chunk.css";
};